import { Badge } from '@estac1/ui';

export interface ProposalRow {
  id: string;
  title: string;
  changes: Array<{ label: string; before: string | null; after: string }>;
  status: 'proposed' | 'applied' | 'refused' | 'failed';
  error: string | null;
  createdAt: string;
}

const STATUS: Record<
  ProposalRow['status'],
  { label: string; variant: 'default' | 'success' | 'warning' | 'danger' }
> = {
  proposed: { label: 'sem resposta', variant: 'default' },
  applied: { label: 'aplicada', variant: 'success' },
  refused: { label: 'recusada', variant: 'warning' },
  failed: { label: 'falhou', variant: 'danger' },
};

/** As mudanças que o assistente propôs na conversa e o que o dono fez com cada uma (#655). */
export const ConversationProposals = ({ proposals }: { proposals: ProposalRow[] }) => {
  if (proposals.length === 0) return null;
  return (
    <div className="space-y-2 border-t border-border pt-3">
      <h3 className="text-xs font-semibold">Propostas de mudança</h3>
      <ul className="space-y-2">
        {proposals.map((p) => (
          <li key={p.id} className="space-y-1 rounded border border-border px-3 py-2 text-sm">
            <p className="flex flex-wrap items-center gap-2">
              <span className="font-medium">{p.title}</span>
              <Badge variant={STATUS[p.status].variant}>{STATUS[p.status].label}</Badge>
            </p>
            {p.changes.map((ch) => (
              <p key={ch.label} className="text-xs text-muted-fg">
                {ch.label}: {ch.before ? `${ch.before} → ` : ''}
                {ch.after}
              </p>
            ))}
            {p.error && <p className="text-xs text-danger">{p.error}</p>}
          </li>
        ))}
      </ul>
    </div>
  );
};
